import { EntityNumberField } from '../../common/EntityNumberField';
import { EntitySampleRangeConfigurator, EntitySampleRangeValidator } from '../../common/EntitySampleRangeConfigurator';
export const EntityIntegerPlugin = {
    type: 'integer',
    edit: {
        field: EntityNumberField
    },
    sampleData: {
        configurator: EntitySampleRangeConfigurator(),
        defaultValue: () => ({ min: 0, max: 9999 }),
        validate: EntitySampleRangeValidator
    }
};
//# sourceMappingURL=EntityIntegerPlugin.js.map